// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CvS3","fullView":"styles_fullView__1W6pk"};